import { Injectable, inject } from '@angular/core';
import { DirtyCheckPlugin, Query } from '@datorama/akita';
import { Models } from '../../models/global.models';
import { LeadStore } from './lead.store';

@Injectable({ providedIn: 'root' })
export class LeadQuery extends Query<Models.LeadForm> {
  protected store: LeadStore;

  dirtyCheck = new DirtyCheckPlugin(this);

  constructor() {
    const store = inject(LeadStore);

    super(store);

    this.store = store;
  }
}
